import { NgForm, NgModel } from "@angular/forms";
import {
  QueryList,
  ViewChildren,
  AfterViewInit,
  ChangeDetectorRef,
  OnInit,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { SubscriberDetails } from "../../../../@api/client-api";
import { CountryService } from "projects/client/src/app/services/country.service";
import { Country } from "projects/client/src/app/models/country";

@Component({
  selector: "newsletter-subscriber-details",
  templateUrl: "./subscriber-details.component.html",
  styleUrl: "./subscriber-details.component.scss",
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SubscriberDetailsComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChildren(NgModel) controls!: QueryList<NgModel>;

  @Input() public details?: SubscriberDetails = {};
  @Input() public serverError: string | null = null;
  @Input() public serverErrorEmail: string | null = null;
  @Output() detailsChange = new EventEmitter<SubscriberDetails>();

  countries: Country[] = [];

  constructor(
    private parentForm: NgForm,
    private countryService: CountryService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.countryService.getCountries().subscribe((data) => {
      this.countries = data.countries;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngAfterViewInit() {
    this.controls.forEach((control: NgModel) => {
      this.parentForm.addControl(control);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["serverError"] || changes["serverErrorEmail"]) {
      this.changeDetectorRef.detectChanges();
    }
  }  

  changed() {
    this.detailsChange.emit(this.details);
  }
}
